import { ApartmentEntity } from '@resident-select/domain/apartment';
import { createEntityEvent } from '../../../shared/base';
import { createAction, props } from '@ngrx/store';

export const CreatedApartmentEvent = createEntityEvent<ApartmentEntity>('CreatedApartmentEvent');
export const GotApartmentsByBuildingIdEvent = createAction('GotApartmentsByBuildingIdEvent', props<{ entities: ApartmentEntity[] }>());
export const DeletedApartmentEvent = createAction('DeletedApartmentEvent', props<{ apartmentId: string }>());
